// src/pages/Blog.js
import React from "react";
import Terms from "../components/Terms";

export default function terms() {
  return <Terms />; // or pass posts={...} popular={...}
}
